enum ErrorCode {
  /** 无权限 */
  NO_PERMISSION = 'NoPermission',
  /** 服务端异常 */
  SERVICE_EXCEPTION = 'ServiceException',
  /** 接口结果异常 */
  RESULT_EXCEPTION = 'ResultException',
  /** 请求超时 */
  TIMEOUT = 'Timeout',
}

export class RequestError extends Error {
  name = 'RequestError';
  code: ErrorCode;

  constructor(code: ErrorCode, message: string) {
    super(message);
    this.code = code;
  }

  toString() {
    return this.message;
  }
}

/** 鉴权失败 */
export class NoPermissionError extends RequestError {
  name = 'NoPermissionError';

  constructor() {
    super(ErrorCode.NO_PERMISSION, '请重新登录');
  }
}

/** 服务器异常 */
export class ServiceExeptionError extends RequestError {
  name = 'ServiceExeptionError';

  constructor(message: string) {
    super(ErrorCode.SERVICE_EXCEPTION, message || '服务器异常');
  }
}

/** 数据返回异常 */
export class ResultExeptionError extends RequestError {
  name = 'ResultExeptionError';

  constructor(message: string) {
    super(ErrorCode.RESULT_EXCEPTION, message || '结果异常');
  }
}
